// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Campaign planner - coming soon page */
.BC-Page__CampaignPlanner .Polaris-Page-Header {
  margin-bottom: 24px;
  padding-bottom: 0;
}

.CampaignPlanner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  max-width: 936px;
  width: 100%;
}

.CampaignPlanner__Sections {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
}

/* ---------- Hero / coming soon card ---------- */
.CampaignPlanner__Hero {
  align-self: stretch;
  display: flex;
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  gap: 16px;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25), 0px 2px 1px rgba(0, 0, 0, 0.05);
}

.CampaignPlanner__HeroContent {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 24px;
}

.CampaignPlanner__HeroHeading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.CampaignPlanner__Badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.CampaignPlanner__Badge--info {
  background: #e0f0ff;
  color: #00527c;
}

.CampaignPlanner__HeroTitle {
  color: #202223;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
}

.CampaignPlanner__HeroSubtitle {
  color: #6d7175;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.CampaignPlanner__Benefits {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.CampaignPlanner__Benefit {
  display: flex;
  align-items: center;
  gap: 8px;
}

.CampaignPlanner__Benefit svg {
  flex-shrink: 0;
}

.CampaignPlanner__Benefit p {
  margin: 0;
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.CampaignPlanner__Benefit strong {
  font-weight: 600;
}

/* ---------- Preview card (BFCM) ---------- */
.CampaignPlanner__PreviewWrap {
  width: 440px;
  padding-right: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.CampaignPlanner__Preview {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 20px;
  border-radius: 16px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%),
    linear-gradient(181deg, #f4fbf8 0%, #ffffff 100%);
  box-shadow: 0px 4px 20px rgba(10, 115, 80, 0.12);
  outline: 1.5px solid #007f5f;
  outline-offset: -1.5px;
}

.CampaignPlanner__PreviewHeader {
  width: 272px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.CampaignPlanner__PreviewHeaderInfo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.CampaignPlanner__Badge--green {
  background: #e2f1ea;
  color: #008060;
  border-radius: 4px;
}

.CampaignPlanner__PreviewName {
  padding: 0 8px;
  color: #202223;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.CampaignPlanner__PreviewToggle {
  display: flex;
  align-items: center;
  gap: 8px;
}

.CampaignPlanner__PreviewToggle span {
  color: #008060;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
}

.CampaignPlanner__PreviewList {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.CampaignPlanner__PreviewItem {
  width: 272px;
  height: 40px;
  padding: 9px 11px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.CampaignPlanner__PreviewItemIcon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  line-height: 18px;
}

.CampaignPlanner__PreviewItemLabel {
  flex: 1 1 0;
  color: #202223;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.CampaignPlanner__PreviewFooter {
  width: 272px;
  height: 44px;
  padding: 6px;
  background: #e2f1ea;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #008060;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

/* ---------- What's inside ---------- */
.CampaignPlanner__Inside {
  align-self: stretch;
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25), 0px 2px 1px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.CampaignPlanner__InsideTitle {
  color: #202223;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.CampaignPlanner__InsideGrid {
  display: flex;
  align-items: stretch;
  gap: 16px;
}

.CampaignPlanner__InsideCard {
  flex: 1 1 0;
  padding: 12px;
  background: #fafbfb;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.CampaignPlanner__InsideCardTop {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.CampaignPlanner__InsideCardIcon {
  padding: 8px;
  background: #e2f1ea;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #007f5f;
}

.CampaignPlanner__Badge--blue {
  background: #e4f7fa;
  color: #2c6ecb;
  border-radius: 4px;
  font-weight: 400;
}

.CampaignPlanner__InsideCardTitle {
  color: #202223;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.CampaignPlanner__InsideCardDesc {
  color: #6d7175;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

@media (max-width: 768px) {
  .CampaignPlanner__Hero {
    flex-direction: column;
    align-items: center;
  }
  .CampaignPlanner__PreviewWrap {
    width: 100%;
    padding-right: 0;
  }
  .CampaignPlanner__InsideGrid {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/campaign-planner.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,4EAA4E;AAC9E;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB;qDACmD;EACnD,gDAAgD;EAChD,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4EAA4E;EAC5E,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* Campaign planner - coming soon page */\n.BC-Page__CampaignPlanner .Polaris-Page-Header {\n  margin-bottom: 24px;\n  padding-bottom: 0;\n}\n\n.CampaignPlanner {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  max-width: 936px;\n  width: 100%;\n}\n\n.CampaignPlanner__Sections {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  width: 100%;\n}\n\n/* ---------- Hero / coming soon card ---------- */\n.CampaignPlanner__Hero {\n  align-self: stretch;\n  display: flex;\n  padding: 20px;\n  background: #ffffff;\n  border-radius: 8px;\n  gap: 16px;\n  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25), 0px 2px 1px rgba(0, 0, 0, 0.05);\n}\n\n.CampaignPlanner__HeroContent {\n  flex: 1 1 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 24px;\n}\n\n.CampaignPlanner__HeroHeading {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.CampaignPlanner__Badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.CampaignPlanner__Badge--info {\n  background: #e0f0ff;\n  color: #00527c;\n}\n\n.CampaignPlanner__HeroTitle {\n  color: #202223;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 30px;\n}\n\n.CampaignPlanner__HeroSubtitle {\n  color: #6d7175;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.CampaignPlanner__Benefits {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.CampaignPlanner__Benefit {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.CampaignPlanner__Benefit svg {\n  flex-shrink: 0;\n}\n\n.CampaignPlanner__Benefit p {\n  margin: 0;\n  color: #000000;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.CampaignPlanner__Benefit strong {\n  font-weight: 600;\n}\n\n/* ---------- Preview card (BFCM) ---------- */\n.CampaignPlanner__PreviewWrap {\n  width: 440px;\n  padding-right: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.CampaignPlanner__Preview {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 20px;\n  border-radius: 16px;\n  background: linear-gradient(0deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%),\n    linear-gradient(181deg, #f4fbf8 0%, #ffffff 100%);\n  box-shadow: 0px 4px 20px rgba(10, 115, 80, 0.12);\n  outline: 1.5px solid #007f5f;\n  outline-offset: -1.5px;\n}\n\n.CampaignPlanner__PreviewHeader {\n  width: 272px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.CampaignPlanner__PreviewHeaderInfo {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.CampaignPlanner__Badge--green {\n  background: #e2f1ea;\n  color: #008060;\n  border-radius: 4px;\n}\n\n.CampaignPlanner__PreviewName {\n  padding: 0 8px;\n  color: #202223;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.CampaignPlanner__PreviewToggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.CampaignPlanner__PreviewToggle span {\n  color: #008060;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 14px;\n}\n\n.CampaignPlanner__PreviewList {\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.CampaignPlanner__PreviewItem {\n  width: 272px;\n  height: 40px;\n  padding: 9px 11px;\n  background: #ffffff;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.CampaignPlanner__PreviewItemIcon {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n.CampaignPlanner__PreviewItemLabel {\n  flex: 1 1 0;\n  color: #202223;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n}\n\n.CampaignPlanner__PreviewFooter {\n  width: 272px;\n  height: 44px;\n  padding: 6px;\n  background: #e2f1ea;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #008060;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n/* ---------- What's inside ---------- */\n.CampaignPlanner__Inside {\n  align-self: stretch;\n  padding: 20px;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25), 0px 2px 1px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.CampaignPlanner__InsideTitle {\n  color: #202223;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.CampaignPlanner__InsideGrid {\n  display: flex;\n  align-items: stretch;\n  gap: 16px;\n}\n\n.CampaignPlanner__InsideCard {\n  flex: 1 1 0;\n  padding: 12px;\n  background: #fafbfb;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.CampaignPlanner__InsideCardTop {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.CampaignPlanner__InsideCardIcon {\n  padding: 8px;\n  background: #e2f1ea;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #007f5f;\n}\n\n.CampaignPlanner__Badge--blue {\n  background: #e4f7fa;\n  color: #2c6ecb;\n  border-radius: 4px;\n  font-weight: 400;\n}\n\n.CampaignPlanner__InsideCardTitle {\n  color: #202223;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.CampaignPlanner__InsideCardDesc {\n  color: #6d7175;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n@media (max-width: 768px) {\n  .CampaignPlanner__Hero {\n    flex-direction: column;\n    align-items: center;\n  }\n  .CampaignPlanner__PreviewWrap {\n    width: 100%;\n    padding-right: 0;\n  }\n  .CampaignPlanner__InsideGrid {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
